/**
 * Which recommender (if any) a product card element belongs to.
 *
 * Shared by the click events (listing-click-analytics.js trackClick) and the
 * add-to-cart handlers, so a click and the confirmed add that follows report
 * the same recommender / recommenderName.
 */

/**
 * Recommender title for an element already known to sit in a recommender.
 * SearchSpring block h3 -> BC carousel data-list-name -> first PDP section heading.
 */
export function getRecommenderName(el) {
    const ssTitle = el.closest('[id^="ss__recommendation--"]')?.querySelector('h3')?.textContent?.trim();
    const carouselName = el.closest('.productCarousel')?.getAttribute('data-list-name')?.trim();
    const pageHeading = document.querySelector('h2.productView-title')?.textContent?.trim();
    return ssTitle || carouselName || pageHeading || null;
}

/**
 * { recommender, recommenderName } for an element inside Recommended Accessories,
 * a SearchSpring recommendation, or a BC product carousel; null otherwise.
 */
export function getRecommenderContext(el) {
    if (el.closest('#recommended_accessories')) {
        return { recommender: 'accessories', recommenderName: 'Recommended Accessories' };
    }
    if (el.closest('[id^="ss__recommendation--"]') || el.closest('.productCarousel')) {
        return { recommender: 'recommender', recommenderName: getRecommenderName(el) };
    }
    return null;
}
